import { useHeader } from "../../../../context/HeaderContext";
import BottomMenu from "../../../../components/Dashboard/BottomMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  useGetPaymentInfoQuery,
  useSubmitPremiumPaymentProofMutation,
  useSubmitPremiumPlusPaymentProofMutation,
} from "../../../../services/addMoneyApi";
import { useGetSpecificUserPremium_PlusAmountQuery } from "../../../../services/userApi";
import { IoCopyOutline } from "react-icons/io5";
import { Notification } from "../../../../components/ToastNotification";
import InlineRefreshIndicator from "../../../../components/InlineRefreshIndicator";
import "./paymentMethods.css";
import { useGetAllPremiumCouponQuery } from "../../../../services/addMoneyApi";
import ViewMore from "./ViewMore";
import BottomSheetModal from "./BottomSheetModal";
import { AiOutlineCloseCircle } from "react-icons/ai";

const PremiumBankTransfer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { amount } = location.state || {};
  // const { setScreenName } = useHeader();
  // useEffect(() => {
  //   setScreenName("Bank Details");
  //   return () => {
  //     setScreenName(null);
  //   };
  // }, []);
  const { data: premiumplusamount } =
    useGetSpecificUserPremium_PlusAmountQuery();

  console.log("premiumplusamountpremiumplusamount", premiumplusamount);
  const discountedPremiumPlusPrice =
    premiumplusamount?.new_price_premium_plus ||
    premiumplusamount?.old_price_premium_plus;
  const {
    data: getcoupon,
    isLoading: loading,
    isError,
  } = useGetAllPremiumCouponQuery({});

  console.log("coupons", getcoupon);

  const coupons = getcoupon?.coupons || [];
  // premiumplusamount
  const isPremiumPlus = amount === discountedPremiumPlusPrice;
  const [transactionId, setTransactionId] = useState("");
  const [singleFile, setSingleFile] = useState(null);
  const [fileUploading, setFileUploading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [visible, setVisible] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Slider navigation
  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? filteredCoupons.length - 1 : prev - 1
    );
  };
  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev === filteredCoupons.length - 1 ? 0 : prev + 1
    );
  };

  // Filtered coupons (Premium or PremiumPlus)
  const filteredCoupons = coupons.filter(
    (coupon) =>
      !coupon.isHide &&
      (isPremiumPlus
        ? coupon.couponFor === "PremiumPlus"
        : coupon.couponFor === "Premium")
  );
  const { data: paymentInfo, isLoading: paymentInfoLoading } =
    useGetPaymentInfoQuery();

  const [submitPremiumPaymentProof] = useSubmitPremiumPaymentProofMutation();

  const discountedPrice = appliedCoupon ? amount - appliedCoupon.value : amount;

  const handleSubmit = async () => {
    if (singleFile) {
      try {
        setFileUploading(true);

        // Create FormData to send image file to backend
        const formData = new FormData();
        formData.append("file", singleFile);
        formData.append("transactionId", transactionId);
        formData.append("payment_mode", "bank_payment");
        formData.append("appliedCoupon", appliedCoupon?.couponId || null);
        formData.append("amount", amount);

        try {
          const response = await submitPremiumPaymentProof(formData);

          if (response.error) {
            Notification(response.error.data.message, "error");
          } else {
            Notification(
              `Request for Premium plan sent successfully`,
              "success"
            );
            setTransactionId("");
            setSingleFile(null);
          }
        } catch (error) {
          console.error(error);
          Notification("An error occurred during submission", "error");
        }
      } catch (error) {
        console.error("Error details:", error);
        Notification("Error uploading the file", "error");
      } finally {
        setFileUploading(false);
      }
    } else {
      Notification("Payment proof image is required", "error");
    }
  };

  const copyToClipboard = (type, text) => {
    navigator.clipboard.writeText(text);
    Notification(`${type} copied`, "success");
  };

  const selectFile = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 3 * 1024 * 1024) {
      alert("Maximum size of images is 3 MB");
    } else {
      setSingleFile(file);
    }
  };

  return (
    // <div className="tpu__premium__wrapper layoutContainer">
    <div className="layoutContainer">
      {/* Header */}
      {/* Body content area */}
      <div className="tpu__premium__section__area">
        <div className="scroll-view">
          {/* Bank Details Card */}
          <div className="tpu-premium-bank-card">
            <h2 className="tpu-premium-bank-card-title">Account Information</h2>
            <div className="info-row">
              <span className="info-label">Account Name:</span>
              <span className="info-text">
                {paymentInfo?.data?.data?.payment_info[0][0]?.bank_info
                  ?.holderName || "N/A"}
              </span>
              <span
                className="copy-icon"
                onClick={() =>
                  copyToClipboard(
                    "Account Name",
                    paymentInfo?.data?.data?.payment_info[0][0]?.bank_info
                      ?.holderName || ""
                  )
                }
              >
                <IoCopyOutline
                  size={22}
                  color={"#007aff"}
                  style={{ cursor: "pointer" }}
                />
              </span>
            </div>
            <div className="info-row">
              <span className="info-label">Account:</span>
              <span className="info-text">
                {paymentInfo?.data?.data?.payment_info[0][0]?.bank_info
                  ?.accountNumber || "N/A"}
              </span>
              <span
                className="copy-icon"
                onClick={() =>
                  copyToClipboard(
                    "Account Number",
                    paymentInfo?.data?.data?.payment_info[0][0]?.bank_info
                      ?.accountNumber || ""
                  )
                }
              >
                <IoCopyOutline
                  size={22}
                  color={"#007aff"}
                  style={{ cursor: "pointer" }}
                />
              </span>
            </div>
            <div className="info-row">
              <span className="info-label">IFSC Code:</span>
              <span className="info-text">
                {paymentInfo?.data?.data?.payment_info[0][0]?.bank_info
                  ?.ifscCode || "N/A"}
              </span>
              <span
                className="copy-icon"
                onClick={() =>
                  copyToClipboard(
                    "IFSC Code",
                    paymentInfo?.data?.data?.payment_info[0][0]?.bank_info
                      ?.ifscCode || ""
                  )
                }
              >
                <IoCopyOutline
                  size={22}
                  color={"#007aff"}
                  style={{ cursor: "pointer" }}
                />
              </span>
            </div>
            <div className="info-row">
              <span className="info-label">Bank Name:</span>
              <span className="info-text">
                {paymentInfo?.data?.data?.payment_info[0][0]?.bank_info
                  ?.bankName || "N/A"}
              </span>
              <span
                className="copy-icon"
                onClick={() =>
                  copyToClipboard(
                    "Bank Name",
                    paymentInfo?.data?.data?.payment_info[0][0]?.bank_info
                      ?.bankName || ""
                  )
                }
              >
                <IoCopyOutline
                  size={22}
                  color={"#007aff"}
                  style={{ cursor: "pointer" }}
                />
              </span>
            </div>
          </div>

          {/* Transaction Details Card */}
          <div className="tpu-premium-bank-card">
            <h2 className="tpu-premium-bank-card-title">Transaction Details</h2>
            <div className="input-container">
              <label className="label">Amount (INR)</label>
              <input
                className="input"
                value={discountedPrice.toString()}
                readOnly
              />
            </div>
            <div className="input-container">
              <label className="label">Transaction Id</label>
              <input
                className="input"
                placeholder="Enter transaction id"
                value={transactionId}
                onChange={(e) => setTransactionId(e.target.value)}
              />
            </div>
          </div>

          <div className="tpu-premium-bank-card">
            <h2 className="tpu-premium-bank-card-title">Coupons</h2>
            {/* Applied Coupon */}
            {appliedCoupon ? (
              <div className="applied-coupon-box">
                <div className="remove-applied-coupon">
                  <button
                    className="remove-coupon"
                    onClick={() => setAppliedCoupon(null)}
                  >
                    <AiOutlineCloseCircle size={18} color="black" />
                  </button>
                </div>
                <div className="applied-coupon-box-inside">
                  <div className="info">
                    <span className="icon">✓</span>
                    <div className="textContainer">
                      <span className="title">Coupon code applied</span>
                      <span className="subtitleText">
                        {appliedCoupon?.shortDescription}! - Unlock
                      </span>
                    </div>
                    <button className="couponTextButton">
                      <span className="couponTextButtonText">
                        {appliedCoupon.couponText}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <span
                style={{
                  alignSelf: "center",
                  marginLeft: "60px",
                  marginTop: "10px",
                  alignItems: "center",
                }}
              >
                Got a coupon code?{" "}
                <span
                  onClick={() => {
                    setVisible(true);
                  }}
                  style={{ color: "purple", cursor: "pointer" }}
                >
                  Apply
                </span>
              </span>
            )}

            <div className="couponBox">
              {/* Coupon Slider */}
              {!loading && (
                <div className="coupon-section">
                  {isError || filteredCoupons.length === 0 ? (
                    <p style={{ alignSelf: "flex-start", marginLeft: "22px" }}>
                      No Coupons Available
                    </p>
                  ) : (
                    <>
                      <div className="slider-wrapper">
                        <button className="nav-btn prev" onClick={handlePrev}>
                          &#10094;
                        </button>

                        <div
                          className="coupon-slider"
                          style={{
                            transform: `translateX(-${currentIndex * 100}%)`,
                          }}
                        >
                          {filteredCoupons.map((coupon) => (
                            <div
                              key={coupon._id}
                              className="coupon-card-container"
                            >
                              <div
                                className={` coupon-card ${
                                  appliedCoupon?.couponId === coupon.couponId
                                    ? "coupon-card-applied"
                                    : ""
                                }`}
                              >
                                <div className="coupon-content">
                                  <span>
                                    <span
                                      className="coupon-code"
                                      style={{
                                        fontFamily: "'Poppins', sans-serif",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {coupon.couponText}
                                    </span>
                                  </span>
                                  <button
                                    onClick={() => setAppliedCoupon(coupon)}
                                    className={`apply-btn ${
                                      appliedCoupon?.couponId ===
                                      coupon.couponId
                                        ? "applied"
                                        : ""
                                    }`}
                                    disabled={
                                      appliedCoupon?.couponId ===
                                      coupon.couponId
                                    }
                                  >
                                    {appliedCoupon?.couponId ===
                                    coupon.couponId ? (
                                      <strong
                                        style={{
                                          backgroundColor: "#28a745",
                                          // border: "1px solid gray",
                                        }}
                                      >
                                        Applied
                                      </strong>
                                    ) : (
                                      <strong>APPLY</strong>
                                    )}
                                  </button>
                                </div>

                                <div className="DescriptionContainer">
                                  <p className="coupon-shortDescription">
                                    {coupon.title}
                                  </p>
                                  <p className="coupon-description">
                                    Get ₹{coupon.value} OFF
                                  </p>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setOpen(true);
                                      setSelectedCoupon(coupon);
                                    }}
                                    className={`ViewMore ${
                                      appliedCoupon?.couponId ===
                                      coupon.couponId
                                        ? "ViewMore-applied"
                                        : ""
                                    }`}
                                  >
                                    View More
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>

                        <button className="nav-btn next" onClick={handleNext}>
                          &#10095;
                        </button>
                      </div>

                      <div className="dot-container">
                        {filteredCoupons.map((_, idx) => (
                          <span
                            key={idx}
                            className={`dot ${
                              idx === currentIndex ? "active" : ""
                            }`}
                            onClick={() => setCurrentIndex(idx)}
                          />
                        ))}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="tpu-premium-bank-card">
            <h2 className="tpu-premium-bank-card-title">
              Upload Payment Proof
            </h2>
            <div className="tpu-premium-upi-input-container">
              <button
                className="file-picker-btn"
                onClick={() => document.getElementById("upload-file").click()}
              >
                <input
                  type="file"
                  id="upload-file"
                  onChange={selectFile}
                  style={{ display: "none" }}
                />
                <span>
                  {singleFile?.name
                    ? singleFile.name.slice(0, 15)
                    : "Choose File"}
                </span>
              </button>
            </div>

            {singleFile && (
              <div className="file-preview">
                <img
                  src={URL.createObjectURL(singleFile)}
                  alt="File preview"
                  className="file-preview__image"
                />
                <div className="file-preview__info">
                  <span>{singleFile?.name}</span>
                </div>
              </div>
            )}
          </div>

          {/* Submit Button */}
          <div className="button-container">
            <button className="button prev" onClick={() => navigate(-1)}>
              Prev
            </button>
            <button
              className={`button submit ${
                !transactionId || !singleFile || fileUploading ? "disabled" : ""
              }`}
              disabled={!transactionId || !singleFile || fileUploading}
              onClick={handleSubmit}
            >
              {fileUploading ? "Uploading..." : "Submit"}
            </button>
          </div>

          <ViewMore
            open={open}
            setOpen={setOpen}
            coupon={selectedCoupon}
            paymentType={"Bank"}
            setSelectedCoupon={setSelectedCoupon}
            appliedCoupon={appliedCoupon}
            setAppliedCoupon={setAppliedCoupon}
          ></ViewMore>
          <BottomSheetModal
            visible={visible}
            isPremiumPlus={isPremiumPlus}
            onClose={() => {
              setVisible(false);
            }}
            allCoupons={coupons}
            setAppliedCoupon={setAppliedCoupon}
          ></BottomSheetModal>
        </div>
      </div>
      {/* Bottom Menu */}
      {/* <BottomMenu /> */}
    </div>
    // </div>
  );
};

export default PremiumBankTransfer;
